module.exports = __webpack_public_path__ + "static/atf-c20cce61647e4ea507f5a24a3b6813c4.gif";